import React from "react";
import InputLabel from "@mui/material/InputLabel";
import cs from "classnames";
import "./styles.scss";
import MenuItem from "@mui/material/MenuItem";
import FormHelperText from "@mui/material/FormHelperText";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";

const SelectDropdown = ({
  label,
  options = [{ value: "", label: "No data  " }],
  size = "small",
  width = 250,
  formControlClass = "",
  id,
  placeholder,
  ...res
}: any) => {
  return (
    <FormControl
      sx={{ m: 1, width }}
      size={size}
      className={cs(
        "select-wrapper-main",
        {
          [formControlClass]: formControlClass,
        },
        { ["large-input"]: (size = "large") },
      )}
    >
      {/*<InputLabel> {label} </InputLabel>*/}
      <Select
        classes={{ outlined: "testing" }}
        {...res}
        disabled={res.isDisable}
      >
        {placeholder && (
          <MenuItem disabled value="">
            {placeholder}
          </MenuItem>
        )}
        {options.map((o, i) => (
          <MenuItem key={i} value={o.value}>
            {o.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default SelectDropdown;
